import script from "./OkrElementWarningIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./OkrElementWarningIcon.vue?vue&type=script&setup=true&lang=js"

import "./OkrElementWarningIcon.vue?vue&type=style&index=0&id=0a60ff78&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a60ff78"]])

export default __exports__